const workspaceSettingsPath = '/workspace-settings';
const workspaceIdParam = 'workspaceId';
const legacyOrganisationIdParam = 'organisationId';
const planTabParamValue = 'plan';

const buildScopedSettingsHref = (path: string, workspaceId: string, tab?: string): string => {
  const searchParams = new URLSearchParams({ [workspaceIdParam]: workspaceId });
  if (tab !== undefined) {
    searchParams.set('tab', tab);
  }
  return `${path}?${searchParams.toString()}`;
};

export const buildWorkspaceSettingsHref = (workspaceId: string): string =>
  buildScopedSettingsHref(workspaceSettingsPath, workspaceId);

export const buildWorkspacePlanSettingsHref = (workspaceId: string): string =>
  buildScopedSettingsHref(workspaceSettingsPath, workspaceId, planTabParamValue);

export const resolveSettingsWorkspaceId = (search: string): string | null => {
  const searchParams = new URLSearchParams(search);
  const workspaceId =
    searchParams.get(workspaceIdParam)?.trim() ??
    searchParams.get(legacyOrganisationIdParam)?.trim() ??
    '';
  return workspaceId.length > 0 ? workspaceId : null;
};
